import { cn } from '@/lib/utils'
import { WizardStepIndicator } from '@/components/wizard/WizardStepIndicator'
import type { ImportWizardShellProps } from '@/types/components/audiences/import-shell'

/**
 * Full-page wizard frame shared by every audience-import step.
 *
 * Mirrors the study-creation wizard layout: a full-width step indicator
 * bar at the top (when `steps` are provided) followed by a centred
 * content column at max-w-7xl with gap-6 vertical spacing.
 */
export function ImportWizardShell({
  children,
  steps,
  onStepNavigate,
  title,
  description,
  titleAction,
  className,
}: ImportWizardShellProps) {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      {steps && steps.length > 0 ? (
        <WizardStepIndicator steps={steps} onNavigate={onStepNavigate} />
      ) : null}
      <div
        className={cn(
          'w-full max-w-screen-2xl mx-auto flex-1 flex min-h-0 flex-col gap-6 px-4 sm:px-8 pt-4 sm:pt-8 pb-0',
          // Extra bottom space on mobile so content is never hidden under the sticky action bar
          'pb-4 md:pb-0',
          className,
        )}
      >
        {title ? (
          <div className="mb-2 flex flex-col gap-3">
            <div className="flex items-center gap-2">
              <h1 className="font-display text-2xl sm:text-4xl font-normal leading-[1.2] text-white">
                {title}
              </h1>
              {titleAction}
            </div>
            {description ? (
              <p className="text-lg leading-[1.4] text-[#BDBDBD]">
                {description}
              </p>
            ) : null}
          </div>
        ) : null}
        {children}
      </div>
    </div>
  )
}
